import VueRouter from 'vue-router';
const {isNavigationFailure, NavigationFailureType} = VueRouter;

export default function handleRouterError (err) {
  if (isNavigationFailure(err, NavigationFailureType.duplicated)) {
    console.warn('[Router] Avoided redundant navigation to current route');
    return;
  }

  if (isNavigationFailure(err, NavigationFailureType.cancelled)) {
    console.warn('[Router] Navigation canceled');
    return;
  }

  throw err;
}
